module.exports = __webpack_public_path__ + "images/circle-3.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/circle-3.png
// module id = 839
// module chunks = 121